// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Km7z","col":"styles_col__3xHqH"};